import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Card, Divider, Grid, Typography, useTheme } from '@mui/material';
import { ButtonBasic } from '../../components';

const ModalHistorialEquipoSoftland = ({show, hideModal,items, idRegistrado}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='xs' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {`Activos: ${idRegistrado}`}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        {(Array.isArray(items) && items?.length > 0) ? (
                            items.map((it)=>(
                                <Grid item xs={12}>
                                    <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important', boxShadow: 3, padding: 1, border: isDarkMode ? '1px solid #3d4a62' : 'none'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'row', marginTop: 1}}>
                                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'normal'}} component='div'>
                                                Nombre: <Box fontWeight='bold' display='inline'>{it?.articulo || '-'}</Box>
                                            </Typography>
                                        </Box>
                                        <Box sx={{display: 'flex', flexDirection: 'row', marginTop: 1}}>
                                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'normal'}} component='div'>
                                                Tipo: <Box fontWeight='bold' display='inline'>{it?.tipo || '-'}</Box>
                                            </Typography>
                                        </Box>
                                        <Box sx={{display: 'flex', flexDirection: 'row', marginTop: 1}}>
                                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'normal'}} component='div'>
                                                Ubicación: <Box fontWeight='bold' display='inline'>{it?.ubicacion || '-'}</Box>
                                            </Typography>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))
                        ):(
                            <Box sx={{background: isDarkMode ? '#1F2A40' : '#f1f1f1',p: 1, borderRadius: 1, width: '100%'}}>
                                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',textAlign: 'center'}} variant='h5'>
                                    Sin activos encontrados.
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cerrar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalHistorialEquipoSoftland